import styled from 'styled-components';

import { Card } from '../../../element';

export const PayBlock = styled(Card)`
  min-height: 180px;
  display: flex;
  align-items: center;

  & .el-card__body {
    flex: 1;
  }
`;
